import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
import { RecoverySharedNamespace } from "./recovery/shared.js";
class RecoveryNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the _bindMissingCustomerToMessage global action. */
    this._bindMissingCustomerToMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_bindMissingCustomerToMessage",
      operationName: "_bindMissingCustomerToMessage",
      operationReturnType: "RecoveryBindMissingCustomerToMessage",
      namespace: "recovery",
      variables: {}
    });
    /** Executes the _bindShopifyOrderToMessage global action. */
    this._bindShopifyOrderToMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_bindShopifyOrderToMessage",
      operationName: "_bindShopifyOrderToMessage",
      operationReturnType: "RecoveryBindShopifyOrderToMessage",
      namespace: "recovery",
      variables: { cursor: { required: false, type: "String" } }
    });
    /** Executes the _getMessagesAnalyticsByCustomer global action. */
    this._getMessagesAnalyticsByCustomer = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_getMessagesAnalyticsByCustomer",
      operationName: "_getMessagesAnalyticsByCustomer",
      operationReturnType: "RecoveryGetMessagesAnalyticsByCustomer",
      namespace: "recovery",
      variables: {
        customerId: { required: false, type: "String" },
        fromDate: { required: false, type: "String" }
      }
    });
    /** Executes the _getMissingCustomerToMessageReport global action. */
    this._getMissingCustomerToMessageReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_getMissingCustomerToMessageReport",
      operationName: "_getMissingCustomerToMessageReport",
      operationReturnType: "RecoveryGetMissingCustomerToMessageReport",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the cleanCsvImport global action. */
    this.cleanCsvImport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "cleanCsvImport",
      operationName: "cleanCsvImport",
      operationReturnType: "RecoveryCleanCsvImport",
      namespace: "recovery",
      variables: {}
    });
    /** Executes the getMissingAttributedShopifyOrderOnMessageReport global action. */
    this.getMissingAttributedShopifyOrderOnMessageReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getMissingAttributedShopifyOrderOnMessageReport",
      operationName: "getMissingAttributedShopifyOrderOnMessageReport",
      operationReturnType: "RecoveryGetMissingAttributedShopifyOrderOnMessageReport",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the getMissingContactToCustomCouponCodeReport global action. */
    this.getMissingContactToCustomCouponCodeReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getMissingContactToCustomCouponCodeReport",
      operationName: "getMissingContactToCustomCouponCodeReport",
      operationReturnType: "RecoveryGetMissingContactToCustomCouponCodeReport",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the getMissingCustomerToMessageReport251205 global action. */
    this.getMissingCustomerToMessageReport251205 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getMissingCustomerToMessageReport251205",
      operationName: "getMissingCustomerToMessageReport251205",
      operationReturnType: "RecoveryGetMissingCustomerToMessageReport251205",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the initializeUserCustomer global action. */
    this.initializeUserCustomer = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeUserCustomer",
      operationName: "initializeUserCustomer",
      operationReturnType: "RecoveryInitializeUserCustomer",
      namespace: "recovery",
      variables: { readonly: { required: false, type: "Boolean" } }
    });
    /** Executes the rattrapageShopifyOrdersAttributionReport global action. */
    this.rattrapageShopifyOrdersAttributionReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "rattrapageShopifyOrdersAttributionReport",
      operationName: "rattrapageShopifyOrdersAttributionReport",
      operationReturnType: "RecoveryRattrapageShopifyOrdersAttributionReport",
      namespace: "recovery",
      variables: {
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        customerId: { required: false, type: "String" },
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the retryFailedHttpCalls global action. */
    this.retryFailedHttpCalls = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "retryFailedHttpCalls",
      operationName: "retryFailedHttpCalls",
      operationReturnType: "RecoveryRetryFailedHttpCalls",
      namespace: "recovery",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "recovery",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
    this.shared = new RecoverySharedNamespace(this);
  }
}
export {
  RecoveryNamespace
};
//# sourceMappingURL=recovery.js.map
